const BAD_WORDS = [
  'fuck', 'shit', 'ass', 'bitch', 'damn', 'hell', 'dick', 'cock',
  'pussy', 'cunt', 'bastard', 'slut', 'whore', 'nigger', 'nigga',
  'fag', 'faggot', 'retard', 'kike', 'spic', 'chink',
  'creampie', 'blowjob', 'handjob', 'rimjob',
];

// Common leetspeak substitutions
const LEET_MAP = { '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't', '@': 'a', '$': 's' };

function deleetspeak(word) {
  return word.replace(/[013457@$]/g, ch => LEET_MAP[ch] || ch);
}

// Pre-compile regexes for performance
const BAD_WORD_REGEXES = BAD_WORDS.map(w => new RegExp(`\\b${w}\\b`, 'i'));

export function containsBadWord(text) {
  const lower = text.toLowerCase().trim();

  // Normalize: deleetspeak + collapse repeated letters (fuuuck -> fuck)
  const variants = [
    lower,
    deleetspeak(lower),
    lower.replace(/(.)\1+/g, '$1'),
    deleetspeak(lower).replace(/(.)\1+/g, '$1'),
  ];

  // Word-boundary matching only — no substring matching
  return variants.some(variant =>
    BAD_WORD_REGEXES.some(regex => regex.test(variant))
  );
}
